/*
 * Oppie helpcentre — client-side FAQ filter.
 * Listens on [data-oppie-help-search-input], filters [data-oppie-help-faq-row]
 * within the nearest [data-oppie-help-faq] container by matching the lowercased
 * data-q attribute. Shows no-results state and hides empty groups.
 */
(function () {
  'use strict';

  function init() {
    var input = document.querySelector('[data-oppie-help-search-input]');
    var container = document.querySelector('[data-oppie-help-faq]');
    if (!input || !container) return;

    var rows = Array.prototype.slice.call(
      container.querySelectorAll('[data-oppie-help-faq-row]')
    );
    var groups = Array.prototype.slice.call(
      container.querySelectorAll('.oppie-help-faq__group')
    );
    var emptyEl = container.querySelector('[data-oppie-help-faq-empty]');
    var clearBtn = document.querySelector('[data-oppie-help-search-clear]');
    var form = document.querySelector('[data-oppie-help-search-form]');
    var categoriesSection = document.querySelector('.oppie-help-categories');

    function normalize(value) {
      return (value || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim();
    }

    function apply(query) {
      var q = normalize(query);
      var anyVisible = false;

      rows.forEach(function (row) {
        if (!q) {
          row.hidden = false;
          return;
        }
        var hay = normalize(row.getAttribute('data-q') || '');
        var match = hay.indexOf(q) !== -1;
        row.hidden = !match;
        if (match) anyVisible = true;
      });

      groups.forEach(function (group) {
        var visibleRows = group.querySelectorAll('[data-oppie-help-faq-row]:not([hidden])');
        group.hidden = q && visibleRows.length === 0;
      });

      if (emptyEl) emptyEl.hidden = !q || anyVisible;
      if (clearBtn) clearBtn.hidden = !q;
      if (categoriesSection) categoriesSection.hidden = !!q;
    }

    input.addEventListener('input', function (event) {
      apply(event.target.value);
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        input.value = '';
        apply('');
        input.focus();
      });
    }

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        apply(input.value);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
